<template>
  <div>
    <toolbar @toggleNavigationBar="drawer = !drawer" />
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      class="primary nav gotham-medium"
    >
      <v-toolbar flat class="toolbar primary">
        <router-link :to="{ name: 'Dashboard' }">
          <img
            src="https://res.cloudinary.com/mioven/image/upload/v1610906913/dentoholic/dentoholic_logo.1629a27b.svg"
            width="100px"
          />
        </router-link>
        <!-- <router-link :to="{ name: 'Dashboard' }" class="text">
         Dentoholic Admin
      </router-link> -->
      </v-toolbar>
      <v-list-item link :active-class="'secondary'" :to="{ name: 'Dashboard' }">
        <v-list-item-icon>
          <v-icon v-text="'dashboard'"></v-icon>
        </v-list-item-icon>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>
      <v-list-item link active-class="secondary" :to="{ name: 'user-index' }">
        <v-list-item-icon>
          <v-icon>person</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Users</v-list-item-title>
      </v-list-item>
      <v-list-item link active-class="secondary" :to="{ name: 'admin-index' }">
        <v-list-item-icon>
          <v-icon>people</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Team</v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'product-index' }"
      >
        <v-list-item-icon>
          <v-icon>add_shopping_cart</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Products</v-list-item-title>
      </v-list-item>
      <v-list-item link active-class="secondary" :to="{ name: 'brand-index' }">
        <v-list-item-icon>
          <v-icon>account_tree</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Brands</v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'supplier-index' }"
      >
        <v-list-item-icon>
          <v-icon>people</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Suppliers</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'supplierorder-index' }"
      >
        <v-list-item-icon>
          <v-icon>people</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Supplier Orders</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'category-index' }"
      >
        <v-list-item-icon>
          <v-icon>category</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Categories</v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'subcategory-index' }"
      >
        <v-list-item-icon>
          <v-icon>category</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Subcategories</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'surgery-index' }"
      >
        <v-list-item-icon>
          <v-icon>business</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Surgeries</v-list-item-title>
      </v-list-item>

      <v-list-item link active-class="secondary" :to="{ name: 'order-index' }">
        <v-list-item-icon>
          <v-icon>business</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Orders</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'shipmentprofile-index' }"
      >
        <v-list-item-icon>
          <v-icon>local_shipping</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Shipment Profiles</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        active-class="secondary"
        :to="{ name: 'supplierreview-index' }"
      >
        <v-list-item-icon>
          <v-icon>star_half</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Reviews</v-list-item-title>
      </v-list-item>

      <v-list-group
        :value="1"
        key="Finance"
        prepend-icon="local_shipping"
        color="#fff"
        no-action
        sub-group
      >
        <template v-slot:activator>
          <v-list-item-title>Finance</v-list-item-title>
        </template>

        <v-list-item
          link
          active-class="secondary"
          :to="{ name: 'salesinvoice-index' }"
        >
          <v-list-item-icon>
            <v-icon>print</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Sales Invoices</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          active-class="secondary"
          :to="{ name: 'commissioninvoice-index' }"
        >
          <v-list-item-icon>
            <v-icon>receipt</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Commission Invoices</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          active-class="secondary"
          :to="{ name: 'purchaseinvoice-index' }"
        >
          <v-list-item-icon>
            <v-icon>assignment</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Purchase Invoices</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      drawer: true,
      selectedIndex: 1
    };
  }
};
</script>

<style>
.toolbar {
  font-weight: bold;
  font-size: 18px;
}

.toolbar .text {
  padding-left: 15px;
  color: white;
  text-decoration: none;
}

.item-title {
  font-size: 17px;
  font-weight: 500;
}
.item-sub-title {
  font-size: 15px;
  font-weight: 500;
}

.active {
  font-weight: bold;
}
.primary .v-navigation-drawer__content {
  color: #fff;
}
.primary
  .v-navigation-drawer__content
  .v-list-item--link.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #fff !important;
}
.primary
  .v-navigation-drawer__content
  .v-list-item--link.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled)
  .v-icon.v-icon {
  color: #fff !important;
}
.nav .v-list-item {
  padding: 0 30px;
}
.nav .v-list-item__icon {
  margin: 12px 0;
}
.nav .v-toolbar__content {
  padding: 4px 30px;
}
.nav .v-icon {
  color: #4c5454;
}
.nav a {
  color: #4c5454 !important;
}
.nav .v-list-item__icon:first-child {
  margin-right: 12px;
}
</style>
